module.exports = __webpack_public_path__ + "static/media/header_bg_5.c9feebc4.jpg";